import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { BiLike } from "react-icons/bi"
import img1 from "../../../../assets/img/Services/AI&ML/Banner-Image_Blog_Enterprise-Data-Warehouse.jpg"
import { IoCloudDoneOutline } from "react-icons/io5";
import { MdOutlineQueryStats } from "react-icons/md";

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
      <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Data Warehousing
            </h1>
            <p className="text-lg text-gray-600">
            Build scalable data lakes and warehouses with Snowflake, BigQuery, Redshift, and Azure Synapse.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <BiCoinStack className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Scalable Data Storage</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Build robust data lakes and warehouses to handle large volumes of structured and unstructured data using Snowflake, BigQuery, and Redshift.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoCloudDoneOutline className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Cloud-Based Data Solutions</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Leverage cloud platforms like Azure Synapse for seamless data integration and storage at scale.
              </p>
            </div>
            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineQueryStats className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900"> Optimized Query Performance</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Implement optimized query structures and indexing techniques to improve data retrieval times and analytics efficiency.
              </p>
            </div>

           
          </div>
        </div>

      
      </div>
    </div>
  )
}